<template>
  <div
    v-if="user"
    class="tab-pane"
    id="pills-user"
    role="tabpanel"
    aria-labelledby="pills-user-tab"
    v-bind:class="
      $route.name == 'Profile' ||
      $route.name == 'Home' ||
      $route.name == 'Search' ||
      $route.name == 'visitProfile'
        ? 'active'
        : ''
    "
  >
    <!-- Start profile content -->
    <div>
      <div class="user-profile-img">
        <div class="p-2 py-4 text-center bg-light text-primary">
          <img
            :src="
              $store.state.config.frontpoint +
              '/storage/small/profile-cover.png'
            "
            class=""
            alt=""
            height="115px"
          />
        </div>
      </div>

      <div
        class="text-center p-3 p-lg-4 border-bottom pt-2 pt-lg-2 mt-n5 position-relative"
      >
        <div class="mb-lg-3 mb-2 position-relative">
          <img
            v-if="user.profile_image != 'non'"
            :src="user.profile_image"
            class="rounded-circle avatar-lg img-thumbnail"
            v-alt="user.useranme"
          />
          <img
            v-else
            :src="
              $store.state.config.frontpoint + 'storage/default-user-photo.png'
            "
            class="rounded-circle avatar-lg img-thumbnail"
            v-alt="user.useranme"
          />
          <div
            v-if="user.activation"
            class="profile-user--activation_light"
            title="User is Activated"
          ></div>
        </div>
        <h4 class="font-size-20 mb-1">
          <div v-if="user.firstname || user.lastname">
            {{ user.firstname }} {{ user.lastname }}
          </div>
          <div v-else>
            {{ user.username }}
          </div>
        </h4>
        <p class="text-muted font-size-14 text-truncate mb-0">
          Registered as
          <span class="fw-bold" v-if="user.roles == 'guest'"> Youth </span>
          <span class="fw-bold" v-if="user.roles == 'administrator'">
            Admin
          </span>
          <span class="fw-bold" v-if="user.roles == 'manager'">
            Practitioner
          </span>
        </p>
      </div>
      <!-- End profile user -->

      <!-- Start user-profile-desc -->
      <div class="p-4 profile-desc" data-simplebar>
        <div>
          <div class="d-flex py-2">
            <div class="flex-shrink-0 me-3">
              <i class="fa-solid fa-user align-middle text-primary"></i>
            </div>
            <div class="flex-grow-1" title="Username">
              <p class="mb-0">{{ user.username }}</p>
            </div>
          </div>
          <div class="d-flex py-2">
            <div class="flex-shrink-0 me-3">
              <i class="fa-solid fa-envelope align-middle text-primary"></i>
            </div>
            <div class="flex-grow-1">
              <a
                :href="'mailto:' + user.email"
                title="Send email"
                class="btn-link"
              >
                <p class="mb-0">{{ user.email }}</p>
              </a>
            </div>
          </div>
          <div v-if="user.jobtitle" class="d-flex py-2">
            <div class="flex-shrink-0 me-3">
              <i class="bx bxs-briefcase align-middle text-primary"></i>
            </div>
            <div class="flex-grow-1">
              <p class="mb-0">{{ user.jobtitle }}</p>
            </div>
          </div>

          <div v-if="user.organization" class="d-flex py-2">
            <div class="flex-shrink-0 me-3">
              <i class="fa-solid fa-house-laptop align-middle text-primary"></i>
            </div>
            <div class="flex-grow-1">
              <p class="mb-0">{{ user.organization }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- end user-profile-desc -->
    </div>
    <!-- End profile content -->
  </div>
</template>

<script>
export default {
  name: "Profile",

  data() {
    return { user: undefined };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadData();
    });
  },

  watch: {
    "$route.params.username"() {
      this.loadData();
    },
  },

  methods: {
    loadData() {
      this.$store.state.modules.api
        .getUserByUsername(this.$route.params.username)
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.loaded = true;
            this.user = resp.data.user;
          } else {
            this.user = this.$store.state.modules.account.user;
          }
        });
    },
  },
};
</script>
